import styled from 'styled-components'

export const Button = styled.div`
  background: #2d60ff;
  padding: 10px;
  box-shadow: 4px 4px 18px -10px rgba(218, 221, 232, 0.8);
  display: flex;
  justify-content: center;
  border-radius: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const Link = styled.a`
  color: white;
  font-family: 'Inter';
  font-size: 14px;
  text-decoration: none;
  font-weight: 600;
`
